import { render, staticRenderFns } from "./gerenciarMetodos.vue?vue&type=template&id=a8e9f7ba"
import script from "./gerenciarMetodos.vue?vue&type=script&lang=js"
export * from "./gerenciarMetodos.vue?vue&type=script&lang=js"
import style0 from "./gerenciarMetodos.vue?vue&type=style&index=0&id=a8e9f7ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports